/**
 * Finds the min and max of a set of points, skipping missing values, which arrive as NaN.
 * Math.min and Math.max propagate NaN, so a single gap would otherwise poison the extent.
 * Returns undefined when no point has a usable value.
 */
export function finiteExtent<T>(points: T[], accessor: (point: T) => number): { min: number, max: number } | undefined {
	let min = Infinity
	let max = -Infinity

	for (const point of points) {
		const value = accessor(point)

		if (!Number.isFinite(value)) {
			continue
		}

		min = Math.min(min, value)
		max = Math.max(max, value)
	}

	return min <= max ? { min, max } : undefined
}
